import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=2addbd5f&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=2addbd5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports